import getBaseURL from "../../utils/getBaseURL.js";

const Swagger = (props) => {

    return (
        <div style={{ width: '100%', height: '91vh' }}>
            <iframe
                src={`${getBaseURL()}/api-docs/${props.email}`}
                title="API Docs"
                style={{ border: 0, width: '100%', height: '100%' }}>

            </iframe>
        </div >
    )
}

export default Swagger
